import { IPreloadedState } from 'shared/types/redux';

export const selectOpenedFilter = (state: IPreloadedState) => state.searchMetaTooltip.openedFilter;
